import React from "react";
import "../ReporteDocente.css";

const Equipo = ({ docente }) => {
  const elaboradoPor = docente["Docente de Seguimiento"];
  const revisadoPor = docente["Docente de Seguimiento III"];

  const getIniciales = (nombre) =>
    nombre
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase();

  return (
    <div className="card elaborado-revisado">
      {/* Elaborado por */}
      <div className="left-section-final">
        <div className="placeholder-foto-final">{getIniciales(elaboradoPor)}</div>
        <div className="info-final">
          <p>Elaborado por</p>
          <p>
            <strong>{elaboradoPor}</strong>
          </p>
        </div>
      </div>

      {/* Línea divisoria */}
      <div className="divider"></div>

      {/* Revisado por */}
      <div className="right-section-final">
        <div className="placeholder-foto-final">{getIniciales(revisadoPor)}</div>
        <div className="info-final">
          <p>Revisado por</p>
          <p>
            <strong>{revisadoPor}</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Equipo;
